import DiscountCodeComponent from './DiscountCodeComponent';

export default DiscountCodeComponent; 